export function waitForElement(selector, timeoutMs = 10000) {
  const start = Date.now();

  return new Promise((resolve) => {
    const tick = () => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(true);
        return;
      }

      if (Date.now() - start >= timeoutMs) {
        resolve(false);
        return;
      }

      window.requestAnimationFrame(tick);
    };

    tick();
  });
}

export function waitForAllElements(selectors = [], timeoutMs = 10000) {
  return selectors
    .reduce((promiseChain, selector) => promiseChain.then((allFound) => {
      if (!allFound) {
        return false;
      }

      return waitForElement(selector, timeoutMs).then((exists) => exists);
    }), Promise.resolve(true));
}

export function scrollTablesToRight(tableSelectors = []) {
  tableSelectors.forEach((tableSelector) => {
    const tableElement = document.querySelector(tableSelector);
    if (!tableElement) {
      return;
    }

    const scrollContainer = tableElement.querySelector('.v-data-table__wrapper') || tableElement;
    const maxScrollLeft = Math.max(0, scrollContainer.scrollWidth - scrollContainer.clientWidth);
    scrollContainer.scrollLeft = maxScrollLeft;
  });
}
